"use client";

import { useEffect, useState } from "react";
import { useStock } from "@/context/StockContext";

export function Toast() {
  const { toast } = useStock();
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!toast) return;
    setMsg(toast.msg);
    setShow(true);
    const t = setTimeout(() => setShow(false), 2800);
    return () => clearTimeout(t);
  }, [toast]);

  return (
    <div id="toast" role="status" className={show ? "show" : ""}>
      {msg}
    </div>
  );
}
